import React, { useContext, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DescriptionIcon from '@material-ui/icons/DescriptionRounded';
import './Chapters.css';
import '../players/video/index.css';

import WebcastingContext from '../../context/webcasting/webcastingContext';
import TranscriptContext from '../../context/TranscriptContext';

// HELPERS
import { getCurrentIndex } from '../../helpers';
import { gaEvent } from '../../helpers/reactGA';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Chapters = ({ preview, transcriptOnly = false }) => {
  const classes = useStyles();
  const { isOpen: transcriptOpen, toggleTranscript } = useContext(TranscriptContext);
  const webcastingContext = useContext(WebcastingContext);
  const {
    event,
    seekToTime,
    playerCurrentTime,
    getCurrentThumb,
    getSeekingTime,
    getProgressBarCurrentTime,
  } = webcastingContext;

  const showTranscription = !!event?.webcast?.layout?.showTranscript;

  let chaptersArr = [];
  const [activeChap, setActiveChap] = useState(0);

  if (!transcriptOnly && event.slides) {
    event.slides.filter((slide, index) => {
      if (slide.name !== '-') {
        chaptersArr.push({ index, name: slide.name, time: slide.time });
      }
      return null;
    });
  }

  useEffect(() => {
    if (transcriptOnly) return;
    let t = playerCurrentTime || seekToTime;
    setActiveChap(getCurrentIndex(t, chaptersArr));
    // eslint-disable-next-line
  }, [playerCurrentTime, seekToTime]);

  const GAchapterOpen = () => {
    gaEvent('chapter', 'chapter_list', 'open');
  };

  const transcriptBtn = showTranscription ? (
    <button
      type='button'
      onClick={(e) => { e.stopPropagation(); toggleTranscript(); }}
      className={`show-transcript-btn${transcriptOpen ? ' show-transcript-btn--active' : ''}`}
      aria-expanded={transcriptOpen}
      aria-controls='transcript-panel'
    >
      <DescriptionIcon style={{ fontSize: '1.1rem' }} />
      Transcript
    </button>
  ) : null;

  // Layouts that don't use chapters — render the transcript button only (if enabled)
  if (transcriptOnly) {
    if (!showTranscription) return null;
    return (
      <div className='chapters-container chapters-container--transcript-only'>
        {transcriptBtn}
      </div>
    );
  }

  if (chaptersArr.length !== 0) {
    return (
      <div className='chapters-container'>
        <div className='chapters-row'>
          <FormControl variant='outlined' className={classes.formControl}>
            <InputLabel id='chapters-select' style={{ zIndex: 0 }}>
              Chapters
            </InputLabel>
            <Select
              labelId='chapters-select'
              id='chapters-select'
              value={activeChap}
              onOpen={GAchapterOpen}
              onChange={(event) => {
                getSeekingTime(chaptersArr[event.target.value].time);
                getCurrentThumb(chaptersArr[event.target.value].index);
                getProgressBarCurrentTime(chaptersArr[event.target.value].time);
                setActiveChap(event.target.value);
                gaEvent(
                  'chapter',
                  'changed',
                  `chapter name: ${chaptersArr[event.target.value].name}`
                );
              }}
              label='Chapters'
            >
              {chaptersArr.map((c, i) => (
                <MenuItem key={i} title={c.name} value={i}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {transcriptBtn}
        </div>
      </div>
    );
  }

  // Chapters layout but this event has no named chapters — transcript only (if enabled)
  if (!showTranscription) return null;
  return (
    <div className='chapters-container chapters-container--transcript-only'>
      {transcriptBtn}
    </div>
  );
};

export default React.memo(Chapters);
